import React from "react";

export const CopyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-check2"
    viewBox="0 0 16 16"
  >
    <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
  </svg>
);

export const CheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="currentColor"
    className="bi bi-copy"
    viewBox="0 0 16 16"
  >
    <path
      fillRule="evenodd"
      d="M4 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 5a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-1h1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h1v1z"
    />
  </svg>
);

export const CSSIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="currentColor"
    width="24"
    height="24"
  >
    <path d="M5 4l3 34 16 6 16-6 3-34H5zm26.6 28.5L24 35l-7.6-2.5-.4-4.6h3.3l.2 2.5 4.5 1.5 4.6-1.4.5-5.1H15.5L15 19h17.8l-.9 11.3zM31.5 16H16.5l-.4-4h15.9l-.5 4z" />
  </svg>
);

export const FlexBoxIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 17V7H8V17H6Z" fill="currentColor" />
    <path d="M16 7V17H18V7H16Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3H22V21H2V3ZM4 5V19H20V5H4Z"
      fill="currentColor"
    />
  </svg>
);

export const GridIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M7 7V11H11V7H7Z" fill="currentColor" />
    <path d="M13 7H17V11H13V7Z" fill="currentColor" />
    <path d="M13 13V17H17V13H13Z" fill="currentColor" />
    <path d="M7 13H11V17H7V13Z" fill="currentColor" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 3H21V21H3V3ZM5 5V19H19V5H5Z"
      fill="currentColor"
    />
  </svg>
);

export const AnimationIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    width="24"
    height="24"
  >
    <path d="M12 4.5c-4.1 0-7.5 3.4-7.5 7.5S7.9 19.5 12 19.5 19.5 16.1 19.5 12 16.1 4.5 12 4.5zm0 14c-3.6 0-6.5-2.9-6.5-6.5S8.4 6.5 12 6.5s6.5 2.9 6.5 6.5-2.9 6.5-6.5 6.5zM12 2v2.5c0 .6-.4 1-1 1s-1-.4-1-1V2c0-.6.4-1 1-1s1 .4 1 1zM4.5 12h2.5c.6 0 1 .4 1 1s-.4 1-1 1H4.5c-.6 0-1-.4-1-1s.4-1 1-1zM16.5 12h2.5c.6 0 1 .4 1 1s-.4 1-1 1h-2.5c-.6 0-1-.4-1-1s.4-1 1-1zM12 20v2.5c0 .6-.4 1-1 1s-1-.4-1-1V20c0-.6.4-1 1-1s1 .4 1 1zM3.7 4.3c.3.4.2.9-.1 1.2s-.9.2-1.2-.1c-.3-.4-.2-.9.1-1.2s.9-.2 1.2.1zM18.4 19.7c-.3-.4-.2-.9.1-1.2s.9-.2 1.2.1.2.9-.1 1.2-.9.2-1.2-.1zM19.7 3.7c.3.4.2.9-.1 1.2s-.9.2-1.2-.1-.2-.9.1-1.2.9-.2 1.2.1zM4.3 18.4c-.3-.4-.2-.9.1-1.2s.9-.2 1.2.1.2.9-.1 1.2-.9.2-1.2-.1z" />
  </svg>
);

export const SassIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="currentColor"
    width="24"
    height="24"
  >
    <path d="M420.75 191.08c-2.8-40.5-32.3-71.93-86.18-91.93-34.13-12.44-58.75-19.55-85.27-34.88-14.77-8.14-29.33-18.24-41.08-31.75-11.62-13.35-20.93-31.82-19.67-50.12.85-11.93 6.96-26.35 13.32-30.95.9-.66-7.4 3.68-14.02 8.34-17.38 12.66-41.75 39.07-46.86 64.75-5.96 27.97 3.54 52.17 25.18 74.5 16.85 17.57 37.48 31.7 57.97 44.63 19.72 12.43 41.42 22.82 62.28 33.22 15.8 7.93 30.37 16.78 42.1 30.16 23.1 25.7 16.63 59.75-13.63 77.1-13.1 7.28-27.1 12.1-41.93 14.78-10.38 1.87-20.68 1.56-30.9 3.68-12.2 2.44-24.53 4.4-36.78 6.4-25.3 4.08-50.75 8.34-75.67 15.66-21.86 6.12-46.07 12.82-64.57 26.55-18.27 13.52-31.6 34.25-31.12 58.6.43 22.53 10.23 42.85 26.8 57.88 28.52 26.03 71.1 27.27 107.73 17.85 18.15-4.5 35.8-11.35 52.55-20.68 10.23-5.58 19.7-12.4 28.85-19.85 2.73-2.12 7.07-6.63 5.27-10.23-3.8-7.33-15.5 5.08-16.72 6.3-14.33 13.78-31.5 25.24-50.2 32.47-28.85 11.04-63.56 12.7-89.6-7.08-10.85-8.15-19.1-20.32-23.16-33.65-8.1-26.43 4.67-51.93 27.52-66.35 22.5-14.04 49.15-18.43 74.5-23.25 20.78-3.92 41.8-7.4 62.7-10.66 13.5-2.18 27.3-3.5 40.78-6.35 12.68-2.7 25.35-5.86 37.03-11.5 30.53-14.47 52.5-40.68 55.08-76.35 1.65-21.18-2.52-43.43-13.93-61.92zm-251.7 260.57c-.12-8.92 4.1-18.17 10.7-25.43 9.47-10.08 22.9-15.6 36.53-18.92 13.23-3.24 26.88-5.22 40.33-7.48 14.3-2.38 28.57-4.8 42.93-7.4-4.85 13.65-12.72 26.67-24.88 35.57-16.5 12-39.93 14.82-59.97 14.48-15.88-.26-31.33-3.38-45.08-12.82-1.88-1.27-4.65-3.16-4.57-4.92z" />
  </svg>
);
